module.exports = __webpack_public_path__ + "media/37.87701eae.wav";